export default __webpack_public_path__ + "static/media/warehouse.42dd4b12.png";